export const environment = {
  production: false,
  gaMeasurementId: 'G-QLSX9B2L4H',
};
